import { RouteContext } from "../../RouteContext";
import { ListPage } from "../../common/ListPage";
import { Column, Row } from "../../common/Layout";
import { useStatePair } from "../../../../type/States";
import {
    PanelConstraint,
    SubPanel
} from "../../common/DetailPage";
import { PlaceFunnelAnalyticsValueObject } from "../../../../model/vo/content/place/stats/PlaceFunnelAnalyticsValueObject";
import { PlaceFunnelIO } from "../../../../io/content/place/PlaceFunnelIO";
import {Button} from "@fluentui/react-components";
import {AddFilled} from "@fluentui/react-icons";
import React from "react";

/** 패널 정의 */
type Panel = PanelConstraint | 'FunnelStats' | 'FunnelStatsPerPlace';

/** 패널 설명 */
const panelDescription: Record<Panel, string> = {
    FunnelStats: '노출 일자 전체 퍼널 통계',
    FunnelStatsPerPlace: '플레이스 하나당 퍼널 통계',
};

/** 패널 렌더링 */
const panelContent: Record<Panel, (props: RouteContext) => JSX.Element> = {
    FunnelStats: (props: RouteContext) => (
        <ListPage
            {...props}
            description={PlaceFunnelAnalyticsValueObject.Stats.description}
            list={PlaceFunnelIO.listFunnelStatsPerPlace()}
            count={PlaceFunnelIO.countFunnelStatsPerPlace()}
            detailHref={() => '/not-found'}
            initialSearchConditions={[
                {
                    name: 'deletedAt',
                    value: '',
                    condition: 'IsNull',
                },
            ]}
        />
    ),
    FunnelStatsPerPlace: (props: RouteContext) => (
        <ListPage
            {...props}
            description={PlaceFunnelAnalyticsValueObject.TotalStats.description}
            list={PlaceFunnelIO.listFunnelStatsGroupedByExposedAt()}
            count={PlaceFunnelIO.countFunnelStatsGroupedByExposedAt()}
            detailHref={() => '/not-found'}
        />
    ),
};

export default function PlaceFunnelStatsList(props: RouteContext) {
    const panelState = useStatePair<Panel>('FunnelStats');

    return (
        <Column gap={'8px'}>
            <Row>
                <Button
                    as={'a'}
                    appearance={'primary'}
                    icon={<AddFilled />}
                    href={'/admin/places/funnels/stats/post'}
                    target={'_blank'}>
                    노출일자 추가
                </Button>
            </Row>
            <Row>
                <SubPanel
                    {...props}
                    panelState={panelState}
                    panelDescription={panelDescription}
                    item={{} as any}
                />
                <Column marginLeft="12px" style={{ flexGrow: 1 }}>
                    {panelContent[panelState.value](props)}
                </Column>
            </Row>
        </Column>
    );
}
